import { Coffee, GraduationCap, Megaphone, Users, type LucideIcon } from "lucide-react";
import {
  sessionEventTypeToIconKey,
  type SessionIconKey,
} from "../utils/training-session-banner.ts";

const ICON_MAP: Record<SessionIconKey, LucideIcon> = {
  graduation: GraduationCap,
  coffee: Coffee,
  megaphone: Megaphone,
  users: Users,
};

export type SessionEventTypeIconProps = {
  eventType: string;
  className?: string;
  "aria-hidden"?: boolean;
};

export function SessionEventTypeIcon({
  eventType,
  className,
  "aria-hidden": ariaHidden = true,
}: SessionEventTypeIconProps) {
  const Icon = ICON_MAP[sessionEventTypeToIconKey(eventType)];
  return <Icon className={className} aria-hidden={ariaHidden} />;
}
